import React from 'react';
import crypto from 'crypto';
import { observer, inject } from 'mobx-react';
import { Form, Icon, Input, Button } from 'antd';
const FormItem = Form.Item;
import styles from './Login.less';

@inject('loginStore')
@observer
class LoginForm extends React.Component {
  constructor(props) {
    super(props);
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const password = crypto
          .createHash('md5')
          .update(values.password)
          .digest('hex');
        this.props.loginStore.login(values.userName, password);
      }
    });
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className={styles.mcloudLogin}>
        <div className={styles.form}>
          <Form onSubmit={this.handleSubmit} className="login-form">
            <FormItem>
              {getFieldDecorator('userName', {
                rules: [{ required: true, message: '请输入用户名!' }]
              })(
                <Input
                  prefix={<Icon type="user" style={{ fontSize: 13 }} />}
                  placeholder="用户名"
                />
              )}
            </FormItem>
            <FormItem>
              {getFieldDecorator('password', {
                rules: [{ required: true, message: '请输入密码!' }]
              })(
                <Input
                  prefix={<Icon type="lock" style={{ fontSize: 13 }} />}
                  type="password"
                  placeholder="密码"
                />
              )}
            </FormItem>
            <FormItem>
              <Button
                type="primary"
                htmlType="submit"
                className={styles.loginBtn}
              >
                登录
              </Button>
            </FormItem>
            {this.props.loginStore.loginError && (
              <p className={styles.loginErr}>用户名/密码错误</p>
            )}
          </Form>
        </div>
      </div>
    );
  }
}
const Login = Form.create()(LoginForm);
export default Login;



// WEBPACK FOOTER //
// ./src/pages/Login/Login.js